
import React, { useState } from "react";
import styles from "./form.component.module.scss";
import { cn } from "../../../../Utils/class-names.utils";
import PlanSelect from "./plan-select.component";
import ClockIcon from "../../../icons/subscription-status/clock.icon";

const FormComponent = () => {
  const [autoRenew, setAutoRenew] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState("Paid Plan 1");

  const plans = ["Paid Plan 1", "Paid Plan 2", "Paid Plan 3"];

  const handleAutoRenewToggle = () => {
    setAutoRenew(!autoRenew);
  };

  const handleCancel = () => {
    console.log("Cancel clicked");
  };

  const handleConvert = () => {
    console.log("Convert clicked", { selectedPlan, autoRenew });
  };

  return (
    <div
      className={styles.container}
      role="dialog"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <p
            id="dialog-title"
            className={styles.title}
          >
            Convert M3 Networks Ltd to a Subscription?
          </p>

          <p
            id="dialog-description"
            className={styles.description}
          >
            This account will licensed for a paid subscription.
          </p>
        </div>

        <div className={styles.planSection}>
          <label
            htmlFor="plan-select"
            className={styles.planLabel}
          >
            Choose Plan
          </label>

          <PlanSelect
            id="plan-select"
            value={selectedPlan}
            onChange={setSelectedPlan}
            plans={plans}
            ariaLabel="Choose subscription plan"
          />
        </div>
      </div>

      <div className={styles.autoRenewSection}>
        <div className={styles.autoRenewContainer}>
          <label
            htmlFor="auto-renew-toggle"
            className={styles.autoRenewLabel}
          >
            Auto-renew
          </label>

          <button
            id="auto-renew-toggle"
            type="button"
            role="switch"
            aria-checked={autoRenew}
            aria-label="Toggle auto-renew"
            onClick={handleAutoRenewToggle}
            className={cn(
              styles.toggle,
              "my-button",
              autoRenew ? styles.active : styles.inactive
            )}
          >
            <div className={styles.toggleThumb} />
          </button>
        </div>

        <div className={styles.renewDateContainer}>
          <ClockIcon />
          <time
            dateTime="2025-11-11"
            className={styles.renewDate}
          >
            Renews 11/11/2025
          </time>
        </div>
      </div>
    </div>
  );
};

export default FormComponent;
